/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-31 14:47:21
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activation\locales\zh-TW.ts
 */
export default {
  'page.activation.txtone': '賬號激活郵件已發送到您的郵箱',
  'page.activation.txtstart': '請在',
  'page.activation.txttime': '60分鐘',
  'page.activation.txtend': '內前往郵箱進行激活',
  'page.activation.btnback': '返回',
  'page.activation.gotoemail': '請前往郵箱進行激活',
  'page.success.txtsucess': '註冊成功，請登錄後及時認證並完善個人信息。',
  'page.activation.txterror': '註冊失敗',
  'page.success.login': '登錄',
  'page.success.regist': '重新註冊',
};
